import Carousel from 'widgets/global/Carousel';

/**
 * @description content carousel implementation
 */
export default class ContentCarousel extends Carousel {
    // code for content carousel
}